<div id="{{sectionId}}" class="collapse" [ngbCollapse]="!expandCollapseStateService.isOpen(sectionId)">
  <ng-content></ng-content>
</div>